<template>
    <div>
        <div v-for="(cue, index) in keys" :key="index">
            <portal v-if="hasKey(cue)" :to="cue">
                    <div
                        class="d-inline"
                        v-if="hasContent(cue)"
                        v-html="getContent(cue)"
                    />
                    <a
                        v-if="hasAdminUrl(cue)"
                        :href="getAdminUrl(cue)"
                        class="btn btn-sm btn-warning"
                        :title="__('Edit')"
                    >
                        <i class="fa fa-edit"></i>
                    </a>
            </portal>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EmbedContentsToPortals',
    props: {
        contents: {
            type: String,
            required: true
        }
    },
    computed: {
        keys() {
            return Object.keys(this._contents)
        }
    },
    data() {
        return {
            _contents: []
        }
    },
    methods: {
        getKey(key) {
            return this._contents[key]
        },
        hasKey(key) {
            const _key = this.getKey(key)
            return typeof _key !== 'undefined'
        },
        hasContent(key) {
            const object = this.getKey(key)
            if (typeof object === 'undefined') { return false }
            return object.hasOwnProperty('content')
        },
        hasAdminUrl(key) {
            const object = this.getKey(key)
            if (typeof object === 'undefined') { return false }
            return object.hasOwnProperty('adminUrl')
        },
        getContent(key) {
            const object = this.getKey(key)
            return object.content
        },
        getAdminUrl(key) {
            const object = this.getKey(key)
            return object.adminUrl
        }
    },
    created() {
        try {
            this._contents = JSON.parse(this.contents)
        } catch(e) {
            console.error(e)
        }
    }
}
</script>